export  default {
    getChangeTrackingByContainer(state) {
        return state.changesContainer;
    },
};